import { useRouter } from 'next/router';
import React, { useEffect, useState, useRef } from 'react';

import Head from 'next/head';
import Axios from 'axios';
import getMetaTagData from '../src/common/services/getMetaTagData';
import AdGenerater from '../src/component/pc/ads/AdGenerater.js';

import Jumbotron from '../src/component/pc/carousel/Jumbotron';
import Slider from '../src/component/pc/carousel/Slider';
import Title from '../src/component/pc/common/Title';
import AdSlider from '../src/component/pc/carousel/AdSlider';
import ServerCheckingEventBanner from '../src/component/pc/event/ServerCheckingEventBanner';

import { deduplArray, deduplChannelArray, toTimeStamp } from '../src/common/utils/convertUtil';
import { convertContentData } from '../src/common/utils/dataConvertUtil';

function Home ({ mainTopData, metaTagData, jWTCheck }) {
  const [mainBottomData, setMainBottomData] = useState([]);
  const [mainNoticeBannerData, setMainNoticeBannerData] = useState(null);

  const [relateContentIndex, setRelateContentIndex] = useState(0);
  const relateContentIndexStatus = { timeoutId: 0, changedTime: Date.now() };
  const childRef = useRef(null);

  // 2depth 바꾸는 부분
  const onChangeMainTopFormationIndex = (index) => {
    const slaveSlideDelayTime = 200;
    // 0.2초 이내에 변경된 경우 슬라이딩 취소
    if (Date.now() - relateContentIndexStatus.changedTime < slaveSlideDelayTime) {
      if (relateContentIndexStatus.timeoutId > 0) {
        clearTimeout(relateContentIndexStatus.timeoutId);
        relateContentIndexStatus.timeoutId = 0;
        relateContentIndexStatus.changedTime = Date.now();
      }
    }

    const timeoutId = setTimeout(() => {
      relateContentIndexStatus.changedTime = Date.now();
      setRelateContentIndex(index);
    }, slaveSlideDelayTime);
    relateContentIndexStatus.timeoutId = timeoutId;
  };

  const mainOnMouseOver = (e) => {
    childRef.current.mainOnMouseOver(e);
  };

  const mainOnMouseOut = (e) => {
    childRef.current.mainOnMouseOut(e);
  };

  useEffect(async () => {
    setMainBottomData(await getMainBottomData());
    setMainNoticeBannerData(await getMainNoticeBannerData());
  }, []);

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />

        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div className='contents'>

        <div role='main' id='container' className='main_listcontents_wrap'>
          {/* 페이지 명 클래스  */}
          <h2 className='hide'>메인컨텐츠</h2>

          {/* 상단 비쥬얼영역 */}
          <div className='main_contents_spot'>
            {mainTopData != null ? (<Jumbotron data={mainTopData} props={{ type: 'modulebox' }} onChangeCurrentIndex={onChangeMainTopFormationIndex} ref={childRef} />) : (<div />)}
          </div>
          {/* 상단 비쥬얼 관련 컨텐츠 */}

          {mainTopData != null
            ? (
              <div className='main_contents_subspot' onMouseOver={(e) => mainOnMouseOver(e)} onMouseOut={(e) => mainOnMouseOut(e)}>
                <ul className='subspot_list_w'>
                  {mainTopData.map((item, index) => {
                    const relateContentList = Array.isArray(item.relate_contents) && item.relate_contents.length > 0 ? item.relate_contents : [];
                    return (
                      <li key={index} className={`subspot_list_inner${relateContentIndex === index ? ' current' : ''}`} aria-hidden={`${relateContentIndex === index ? 'false' : 'true'}`}>
                        {item.relate_title_view_yn === 'Y' && <Title view={relateContentIndex === index} title={item.relate_title} desc={item.desc} />}
                        <Slider
                          view={relateContentIndex === index}
                          key={'s_' + index}
                          type='thumb'
                          data={relateContentList}
                          relate_id={item.relate_id}
                          relate_title={item.relate_title}
                          relate_title_view_yn={item.relate_title_view_yn}
                          relate_type={item.relate_type}
                          clickParams='div=main_top_relate'
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>)
            : (<div />)}

          {/* 하단 비쥬얼 관련 컨텐츠 */}
          {mainBottomData != null
            ? mainBottomData.map((item, index) => {
              // {mainBottomData.filter(x => Array.isArray(x.contens) || Array.isArray(x.contents)).map((item, index) => {
                let clickParamLink = '';
                try {
                  if(item.list_code=='pnews'){
                    clickParamLink = 'utm_source=sbsmain';
                  }else{
                    clickParamLink = 'div=main_' + item.list_code;
                  }
                } catch (error) {
                  
                }
              return (
                <AdSlider
                  key={index.toString()}
                  index={index}
                  slide_key={index}
                  title={item.title || item.pgm_nm}
                  desc={item.desc || item.title}
                  link={item.link || ''}
                  type={item.bottom_type}
                  data={item.contents}
                  relate_id={item.relate_id}
                  relate_title={item.relate_title}
                  relate_title_view_yn={item.relate_title_view_yn}
                  relate_type={item.relate_type}
                  bottom_type={item.bottom_type}
                  clickParams={clickParamLink}
                  ord_no={item.ord_no}
                  jwt_check={jWTCheck}
                />
              );
            })
            : (<div />)}
        </div>

        <AdGenerater id='bottom' />

        {mainNoticeBannerData && <ServerCheckingEventBanner {...mainNoticeBannerData} />}
      </div>
    </>
  );
}

export async function getServerSideProps (ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);
  const mainBottomDataJob = getMainBottomData();
  const mainTopData = await getMainTopData();

  if (Array.isArray(mainBottomDataJob) && mainBottomDataJob.length > 0) {
    const themeTitleList = mainBottomDataJob.map(item => item.title);

    if (metaTagData.keywords) {
      metaTagData.keywords = metaTagData.keywords + ',' + themeTitleList.toString();
    } else {
      metaTagData.keywords = themeTitleList.toString();
    }
  }

  return { props: { mainTopData, metaTagData, jWTCheck } };
}

const getMainTopData = async () => {
  let result = [];

  try {
    const mainTopApiData = await Axios.get(process.env.NEXT_PUBLIC_API_MAIN_TOP, { timeout: 3000 });
    const onairData = await getLiveChannelData();
    // TODO childmild 해당 여역 부분에 jwt 로 로그인해서 내가 본 프로그램 호출 뿌리는 로직 만들기
    // 1. 로그인 jwt 값이 있는지 체크
    // 2. 있을시 내가 본 프로그램 api 호출 : https://apis.sbs.co.kr/play-api/1.0/sbs_myvods/programs?jwt-token=

    // const jwtToken = jwtCheck();
    const mainTopApiDataList = mainTopApiData?.data;

    if (Array.isArray(mainTopApiDataList) && mainTopApiDataList.length > 0) {
      result = mainTopApiDataList.sort((x, y) => x - y)
        .map((x, idx) => {
          const result = convertContentData(x, false, idx, onairData);
          result.relate_contents = x.relate_contents.map((y, index) => {
            return convertContentData(y, false, index);
          });

          return result;
        });
    }
  } catch (error) {
    console.error(error);
  }

  return result;
};

const getMainBottomData = async () => {
  let result = [];

  try {
    const mainBottomDataJob = Axios.get(process.env.NEXT_PUBLIC_API_MAIN_BOTTOM, { timeout: 3000 });
    const [mainBottomApiData, onairData] = await Promise.all([mainBottomDataJob, getLiveChannelData()]);
    const mainBottomApiDataList = mainBottomApiData?.data;

    // 현재 onair데이터 조회 후 삽입
    if (Array.isArray(mainBottomApiDataList) && mainBottomApiDataList.length > 0) {
      const mainBottomLiveDataIndex = mainBottomApiDataList.findIndex(x => x.bottom_type === 'live');

      mainBottomApiDataList.map((x, index) => {
        if (index !== mainBottomLiveDataIndex && x.contents && Array.isArray(x.contents)) {
          x.contents = x.contents.map(y => {
            const result = {
              img: y.pgm_img_url || '',
              imgDesc: y.pgm_nm || '',
              link: y.link_url || '',
              title: y.title || '',
              desc: y.pgm_nm || '',
              date: '',
              pgm_nm: y.pgm_nm || '',
              link_url: y.link_url || '',
              pgm_img_url: y.pgm_img_url || '',
              m_img_url: y.m_img_url || '',
              time: toTimeStamp(y.playtime),
              target_age: y.target_age || '',
              isfree: y.isfree || '',
              content_date: y.content_date || '',
              content_num: y.content_num || '',
              srs_div: y.srs_div || '',
              srs_no: y.srs_no || '',
              srs_dtl_no: y.srs_dtl_no || '',
              link_new_yn: y.link_new_yn || '',
              // TODO childmild 메인개편 2차 에서 이벤트 바텀 영역 추가되는 파라미터 부분
              img_url: y.img_url || '', // 이미지 파라미터 기존 1차때 쓰는 메인 쪽과  TV 쪽과 틀림
              pc_view_yn: y.pc_view_yn || '', // 피씨 노출여부
              m_view_yn: y.m_view_yn || '' // 모바일 노출여부
            };

            if (x.bottom_type === 'event') {
              result.content = y.img_alt;
            }

            return result;
          });
        }
      });

      if (Array.isArray(onairData) && onairData.length > 0) {
        mainBottomApiDataList[mainBottomLiveDataIndex].desc = '전체채널';
        mainBottomApiDataList[mainBottomLiveDataIndex].link = '/live';
        mainBottomApiDataList[mainBottomLiveDataIndex].contents = onairData;
      } else {
        mainBottomApiDataList.splice(mainBottomLiveDataIndex, 1);
      }

      result = mainBottomApiDataList.sort((x, y) => {
        return x.ord_no - y.ord_no;
      });
    }
  } catch (error) {
    console.error(error);
  }

  return result;
};

const getLiveChannelData = async () => {
  console.log('API_LIVE_CHANNELS :>> ', process.env.NEXT_PUBLIC_API_LIVE_CHANNELS);

  try {
    const mainLiveDataList = await Axios.get(process.env.NEXT_PUBLIC_API_LIVE_CHANNELS, { timeout: 3000 });
    const filteredArray = mainLiveDataList.data.list.filter((item) => (item.type === 'TV' || (item.type === 'Radio' && item.onair_yn === 'Y')));
    const liveChannelArray = deduplChannelArray(filteredArray, 'channelname', 'channelid');

    if (mainLiveDataList.data && Array.isArray(liveChannelArray) && liveChannelArray.length > 0) {
      return liveChannelArray.map(x => {
        return {
          img: (x.channelid !== 'EVENT4') ? x.thumbs?.['640'] || x.thumbimg : x.thumbimg,
          imgDesc: x.title,
          title: x.title,
          desc: (x.channelid !== 'EVENT4') ? x.channelname : 'SBS',
          smr_programid: x.smr_programid,
          // channel_payment: x.channel_payment,
          target_age: x.target_age,
          channelid: x.channelid,
          starttime: x.starttime,
          endtime: x.endtime,
          link: (x.channelid === 'EVENT4' && x.homeurl.length > 0) ? x.homeurl : `/live/${x.channelid}` || '',
          // (PC에서만) 메인페이지에서 EVENT4 && homeurl.length > 0 -> 제작발표회라고 판단될 경우는 링크를 homeurl-제작발표회 템플릿으로 처리한다.
          pgm_nm: x.pgm_nm || '',
          link_url: x.link_url || '',
          pgm_img_url: x.pgm_img_url || '',
          m_img_url: x.m_img_url || '',
          time: toTimeStamp(x.playtime),
          // isfree: x.isfree || '',
          content_date: x.content_date || '',
          content_num: x.content_num || '',
          srs_div: x.srs_div || '',
          srs_no: x.srs_no || '',
          srs_dtl_no: x.srs_dtl_no || '',
          link_new_yn: x.link_new_yn || ''
        };
      });
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
  }
};

const getMainNoticeBannerData = async () => {
  let result = null;

  console.log('NEXT_PUBLIC_URL_MAIN_NOTICE_BANNER_DATA :>> ', process.env.NEXT_PUBLIC_URL_MAIN_NOTICE_BANNER_DATA);

  try {
    const mainNoticeBannerData = await Axios.get(process.env.NEXT_PUBLIC_URL_MAIN_NOTICE_BANNER_DATA, { timeout: 3000 });
    result = mainNoticeBannerData.data ? { ...mainNoticeBannerData.data } : null;

    if (result.pc) {
      result.deviceData = result.pc;
      delete result.pc;
      delete result.mobile;
    }
  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export default Home;
